import { DerrubaSessaoComponent } from 'src/app/components/derruba-sessao/derruba-sessao.component';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { mandatorio, validaEmail } from 'src/app/utils/validadores';
import { MessageHandler } from 'src/app/utils/form-field-message-handler';
import { RegisterIconsService } from 'src/app/services/register-icons.service';
import { ApiS3Service } from 'src/app/services/api-s3.service';
import { GAnalyticsService } from 'src/app/services/g-analytics.service';
import { MatDialog } from '@angular/material/dialog';
import { ControllerStatusService } from 'src/app/services/controller-status.service';
import { Subscription } from 'rxjs';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	errorMessage = MessageHandler.errorMessage;
	subscriptions = new Subscription();
	
	environment = environment;
	utilsService = inject(UtilsService);
	loading: boolean = false;
	mostrarSenha:boolean = false;
	animationOut: boolean = false;
	deslogando: boolean = false;
	btnDisabled: boolean = false;
	element: HTMLElement;

	formLogin = new UntypedFormGroup({
		email: new UntypedFormControl('', { validators: [mandatorio, validaEmail] }),
		senha: new UntypedFormControl('', { validators: [mandatorio] })
	});	

	constructor(
		private router: Router,
		public route: ActivatedRoute,
		public snackBar: MatSnackBar,
		private apiS3: ApiS3Service,
		private gAnalytics: GAnalyticsService,
		private apiUsuario: ApiUsuarioService,
		private controllerStatus: ControllerStatusService,
		private icons: RegisterIconsService,
		private dialog: MatDialog) {

		icons.registerIcons(['eye-off', 'eye', 'loading']);
		this.confirmaUsuario();
	}

	async confirmaUsuario () {
		let page = this.route.snapshot.queryParams['page'];
		let confirmacao = this.route.snapshot.queryParams['confirmacao'];
		if ((page == 'login' || !page) && confirmacao) {
			if (confirmacao) {
				let ret = await this.apiUsuario.confirmaUsuario(confirmacao);
			}

		}
		
	}

	ngOnInit(): void {
		
		this.apiUsuario.listaUsuarios = [];
		this.controllerStatus.stopInterval();
		this.subscriptions.add(this.apiUsuario.deslogandoSessao.asObservable().subscribe(ret=>{
			this.deslogando = ret;
		}))
		setTimeout(()=>{
			this.apiUsuario.deslogar();
		}, 200);
		this.gAnalytics.analyticsPageMonitor('Login', '/apice/login');		
		// console.log('path', this.apiUsuario.pathHistory);
	}

	visibilidadeSenha(event) {
		this.mostrarSenha = !this.mostrarSenha;
		event.preventDefault();
		event.stopPropagation();
	}

	async fazLogin(){

		let allowLogin = this.checkTentativasLogin();

		if(allowLogin){
			this.loading = true;
			this.formLogin.disable();
			const dadosForm = this.formLogin.getRawValue();
			
			try {
				if (this.formLogin.controls.email.value !== '' && this.formLogin.controls.email.value !== '') {
					let credenciais:any = await this.apiUsuario.login(dadosForm);
					
					if(credenciais.statusCorretora && credenciais.statusCorretora == 3){
						await this.apiUsuario.verificaCorretoraMigrada();
						return
					}

					//** verificar se houve licença excedida */
					if (credenciais?.message && credenciais.message == "Sessões lotadas. Escolha algum usuário da corretora para desconectar da sessão."){
						const data = {credenciais, dadosForm}
						let dialog = this.dialog.open(DerrubaSessaoComponent, {
							panelClass: 'modalDefaultP',
							data: data
						});
						dialog.afterClosed().subscribe(ret => {
							this.formLogin.enable();
						})
					} else if (credenciais?.message && credenciais.message == "Já existe uma sessão ativa com esse usuário.") {
						const data = {credenciais, dadosForm}
						let dialog = this.dialog.open(DerrubaSessaoComponent, {
							panelClass: 'modalDefault',
							data: data
						});
						dialog.afterClosed().subscribe(ret => {
							this.formLogin.enable();
						})
					} else if (credenciais?.message && credenciais.message == "Sua sessão foi desconectada!") {
						this.mostraMensagem(credenciais.message);
						this.formLogin.enable();
					} else{

						credenciais['senha'] = dadosForm.senha;
						this.apiUsuario.armazenaLogin(credenciais);
						this.apiUsuario.avatar = await this.apiS3.loadAvatarUsuarioLogado();
						this.animationOut = true;
						let path = '/cotacoes';
						this.router.navigateByUrl(path).then((_) => this.controllerStatus.checkStatusPagamento())
					}
				} else {
					this.formLogin.enable();
					this.mostraMensagem('Preencha seus dados para entrar!');
				}
				
				
			} catch (error) {
				this.animationOut = false;	
				this.formLogin.enable();

				let erro;
				if (error && error.error && error.error.message) {
					erro = error.error.message;
				} 
				else if (error.status == 0) {
					erro = 'Falha de conexão ao servidor.';
				}
				else {
					erro = 'Falha no login.';
				}
				this.mostraMensagem(erro);
			}finally{
				this.loading = false;
			}
		}else{

		}
		
	}

	bloquerBtnLogin: boolean = false;
	tentativasLogin = 0;
	tentativasLoginBackground = 0;
	retentativaLogin;
	timerLogin = 15;
	checkTentativasLogin(){
		this.tentativasLogin++;
		this.tentativasLoginBackground++;
		if(this.tentativasLoginBackground <= 3){
			return true
		}else if(this.tentativasLoginBackground >= 4){
			if(this.tentativasLoginBackground >= 10) {
				this.bloquerBtnLogin = true;
				return false;
			}
			return true
		} else{			
			return false
		}
	}

	mostraMensagem (mensagem: string) {
		this.snackBar.open(mensagem, 'Ok', {
			duration: 6000,
		});
	}

	ngOnDestroy(){
		this.subscriptions.unsubscribe();
	}

}
